module.exports = __webpack_public_path__ + "public/SiteIcons/paidOutIcon.svg?b94f6462";